module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pager"
  }, [(Number(_vm.page) === 1) ? _c('li', [_vm._m(0)]) : _c('li', {
    staticClass: "disabled"
  }, [_c('router-link', {
    attrs: {
      "aria-label": "Previous",
      "to": _vm.clickPage(_vm.page - 1)
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«上一页")])])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.page))]), _vm._v(" "), (_vm.hasMore) ? _c('li', [_c('router-link', {
    attrs: {
      "aria-label": "Next",
      "to": _vm.clickPage(_vm.page + 1)
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»下一页")])])], 1) : _c('li', {
    staticClass: "disabled"
  }, [_c('span', [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»下一页")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«上一页")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1de82bdf!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Pagination.vue
// module id = 282
// module chunks = 6